import React, { useEffect, useState, useRef } from 'react';
import '../css/PaginaPilotoMototaxi.css';
import { buscarDadosPiloto } from '../servicos/listagemServico';
import { atualizarStatusPiloto, atualizarStatusViagemPeloPiloto } from '../servicos/cadastroServico';
import Cookies from 'js-cookie';
import { Link, useNavigate } from 'react-router-dom';
import { BiExit } from 'react-icons/bi';
import LoadingIndicator from '../components/LoadingIndicator'

const PaginaPilotoMototaxi = () => {
  const [dadosPiloto, setDadosPiloto] = useState(null);
  const [statusAtivo, setStatusAtivo] = useState(false);
  const navigate = useNavigate();
  const [posicao, setPosicao] = useState(null);
  const [loadingIndicator, setLoadingIndicator] = useState(true);


  // 🔹 refs para som e wake lock
  const audioRef = useRef(null);
  const wakeLockRef = useRef(null);

  const previousStatusRef = useRef(null);

  // 🔹 Solicitar wake lock para manter a tela ativa
  const ativarWakeLock = async () => {
    try {
      if ('wakeLock' in navigator) {
        wakeLockRef.current = await navigator.wakeLock.request('screen');
        console.log('Wake Lock ativado!');
        wakeLockRef.current.addEventListener('release', () => {
          console.log('Wake Lock liberado!');
        });
      }
    } catch (err) {
      console.warn('Não foi possível ativar o Wake Lock:', err);
    }
  };

const atualizarLocalizacaoNosCookies = () => {
  console.log(' 5 - Entrou em atualizarLocalizacaoNosCookies');

  const cookies = Cookies.get();
  const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

  console.log('dadosCookies.dadosPiloto antes do getCurrentPosition: ');
  console.log(dadosCookies?.dadosPiloto);

  console.log('=> !!! aqui está errado <= (1)');

  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const cookies = Cookies.get();
      const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

      console.log(' 5.1 - dadosCookies.dadosPiloto dentro do getCurrentPosition, antes de atualizar localização: ');
      console.log(dadosCookies?.dadosPiloto);

      // aqui está errado
      console.log('=> !!! aqui está errado <= (2)');

      if (dadosCookies && dadosCookies.dadosPiloto) {

        // const novosDadosCookies = {
        //   ...dadosCookies,
        //   dadosPiloto: {
        //     ...dadosCookies.dadosPiloto,
        //     latitude: pos.coords.latitude,
        //     longitude: pos.coords.longitude,
        //     // Preserva objViagem se já existir
        //     ...(dadosCookies.dadosPiloto.objViagem ? { objViagem: dadosCookies.dadosPiloto.objViagem } : {})
        //   }
        // };

const novosDadosCookies = {
    ...dadosCookies,
    dadosPiloto: {
      ...dadosCookies.dadosPiloto,
      latitude: pos.coords.latitude,
      longitude: pos.coords.longitude,
      // Garante sempre a chave objViagem (mesmo que seja null)
      objViagem: dadosCookies.dadosPiloto.objViagem ?? null
    }
  };



        // Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });
        safeSetDadosCookies(novosDadosCookies);
        

        console.log('Localização atualizada nos cookies:', pos.coords.latitude, pos.coords.longitude);

        console.log('como ficará os dadosCookies.dadosPiloto após atualizar: ');
        console.log(novosDadosCookies.dadosPiloto);

        console.log('=> aqui está correto agora <=');
      } else {
        console.warn('dadosCookies.dadosPiloto não encontrado para salvar localização.');
      }
    },
    (err) => {
      console.error('Erro ao obter localização:', err);
    }
  );
};

const getDadosCookies = (obs) => {
  console.log('======================');
  console.log('Entrou em getDadosCookies()');
  console.log(obs);
  console.log('======================');

  const cookies = Cookies.get();
  const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;
  
  console.log(dadosCookies);

  console.log('===== SAINDO =====');
  return dadosCookies;
}

// Helper seguro para gravar o cookie (use este em todo lugar)
const safeSetDadosCookies = (novosDadosCookies) => {
  console.log('xxxxxxxxxxxxxxxxxxxx');
  console.log('Entrou em safeSetDadosCookies....');
  console.log('novosDadosCookies que chegaram pra serem salvos: ');
  console.log(novosDadosCookies.dadosPiloto);

  try {
    // marca versão/timestamp
    const now = Date.now();
    const toSave = {
      ...novosDadosCookies,
      __lastUpdated: now
    };

    const existingRaw = Cookies.get('dadosCookies');

    console.log('dadosCookies existentes:');
    console.log(existingRaw);
    
    let existing = null;
    try {
      existing = existingRaw ? JSON.parse(existingRaw) : null;
    } catch (e) {
      console.warn('safeSetDadosCookies: erro ao parsear cookie existente', e);
    }

    if (existing && existing.__lastUpdated && existing.__lastUpdated > toSave.__lastUpdated) {
      console.log('safeSetDadosCookies: existe versão mais nova no cookie — não sobrescrevendo', {
        existingLast: existing.__lastUpdated,
        newLast: toSave.__lastUpdated
      });
      return; // não sobrescreve
    }

    const json = JSON.stringify(toSave);
    console.log('safeSetDadosCookies: salvando cookie (bytes):', new Blob([json]).size);
    Cookies.set('dadosCookies', json, { expires: 60, path: '/' });

    // leitura imediata para debug
    const raw = Cookies.get('dadosCookies');
    console.log("safeSetDadosCookies -> Depois de salvar, bruto:", raw);
    try {
      const parsed = raw ? JSON.parse(raw) : null;
      console.log("safeSetDadosCookies -> Depois de salvar, objeto parseado:", parsed);
      console.log("safeSetDadosCookies -> objViagem salvo:", parsed?.dadosPiloto?.objViagem);
    } catch (e) {
      console.error("safeSetDadosCookies -> Erro ao parsear JSON depois de salvar:", e);
    }
  } catch (e) {
    console.error('safeSetDadosCookies: erro ao salvar cookie', e);
  }
};



async function carregarDados() {
  console.log('-----------------------');
  console.log('.....1 - Entrou em carregarDados....');
  console.log('-----------------------');

  try {
    console.log('Preparando para chamar a api buscarDadosPiloto, inclusive se tem viagem....');

    // const cookies = Cookies.get();
    // const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;
    const dadosCookies = getDadosCookies('*** 1 ***');

    console.log('dadosCookies antes da API: ');
    console.log(dadosCookies);

    console.log('dadosCookies.dadosPiloto antes da API: ');
    console.log(dadosCookies.dadosPiloto);

    console.log('Aqui tudo bem o objViagem estar null');

    const dados = await buscarDadosPiloto(dadosCookies);

    console.log(' 3 - Dados recebidos da api buscarDadosPiloto: ');
    console.log(dados);

    console.log('Dados piloto recebidos da api buscarDadosPiloto: ');
    console.log(dados.dadosPiloto);

    console.log('Dados piloto objViagem recebidos da api buscarDadosPiloto: ');
    console.log(dados.dadosPiloto.objViagem);

    console.log('=> aqui tudo certo <= (1)');

    setDadosPiloto(dados.dadosPiloto);

    // 🔹 Som quando chegar PILOTO SOLICITADO
    const statusAtual = dados.dadosPiloto.objPiloto?.nome_status;
    if (statusAtual === 'PILOTO SOLICITADO' && previousStatusRef.current !== 'PILOTO SOLICITADO') {
      if (audioRef.current) {
        audioRef.current.play().catch(err => console.warn('Erro ao tocar áudio:', err));
      }
    }
    previousStatusRef.current = statusAtual;

    console.log('ok, dados do piloto setados!');

    // o problema pode ser aqui:
    // Atualiza cookies preservando objViagem se não vier do backend
    const novosDadosCookies = {
      ...dadosCookies,
      token: null,    // estou deixando null, pois está dando erro no tamanho do cookie
      dadosPiloto: {
        ...dadosCookies?.dadosPiloto,
        ...dados.dadosPiloto,
        // objViagem: dados.dadosPiloto.objViagem ?? dadosCookies?.dadosPiloto?.objViagem ?? null
        objViagem: dados.dadosPiloto.objViagem !== null && dados.dadosPiloto.objViagem !== undefined
        ? dados.dadosPiloto.objViagem
        : dadosCookies?.dadosPiloto?.objViagem

      }
    };

    console.log('*** 4 - Novos dados cookies ***');
    console.log(novosDadosCookies);

    console.log('*** Novos dados cookies - dados piloto ***');
    console.log(novosDadosCookies.dadosPiloto);

    console.log('*** Novos dados cookies - dados piloto - objViagem ***');
    console.log(novosDadosCookies.dadosPiloto.objViagem);
    

    console.log('=> aqui tudo certo <= (2)');

console.log("Antes de salvar nos cookies (carregarDados):", JSON.stringify(novosDadosCookies));
console.log("Tamanho em bytes:", new Blob([JSON.stringify(novosDadosCookies)]).size);
// aqui tudo certo
console.log('=> aqui tudo certo <= (2.1)');

//    Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });

//console.log("Depois de salvar, bruto do Cookies.get('dadosCookies'):", Cookies.get('dadosCookies'));

// Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });
safeSetDadosCookies(novosDadosCookies);

const raw = Cookies.get('dadosCookies');
console.log("Depois de salvar, bruto:", raw);

try {
  const parsed = JSON.parse(raw);
  console.log("Depois de salvar, objeto parseado:", parsed);
  console.log("Depois de salvar, objViagem:", parsed?.dadosPiloto?.objViagem);
} catch (e) {
  console.error("Erro ao parsear JSON:", e);
}

console.log('=> !!! aqui está errado <= (5) - PRIMEIRO ERRO!!!');
// aqui já com erro


    setStatusAtivo(dados.dadosPiloto.objPiloto?.nome_status === 'PILOTO DISPONÍVEL');

    if (dados.dadosPiloto.objPiloto?.nome_status === 'PILOTO EM VIAGEM') {
      setLoadingIndicator(false);
      navigate(`/mapa-indo-ate-cliente`);
    }

    console.log('...preparando para chamar atualizarLocalizacaoNosCookies...');

    const dadosCookies2 = getDadosCookies('*** 2 ***');
    console.log('Dados cookies2.dadosPiloto: - acabou de setar os dadosCookies... ');
    console.log(dadosCookies2.dadosPiloto);

    // aqui está errado
    console.log('=> !!! aqui está errado <= (4)');

    atualizarLocalizacaoNosCookies();

    console.log('!!! 6 - saindo do carregarDados !!!!');

  } catch (erro) {
    if (erro.response) {
      const { message } = erro.response.data;
      alert(message);
    } else {
      alert("Erro ao buscar os dados. Tente novamente.");
    }
    handleLogout();
  } finally {
    setLoadingIndicator(false);
  }
}



  useEffect(() => {
    ativarWakeLock();

    console.log('=======================');
    console.log('!!!! Entrou no useEffect da PaginaPilotoMototaxi....');


    console.log('Preparando para chamar o método carregarDados...');
    carregarDados();

    const interval = setInterval(() => {
      carregarDados();
    }, 10000);

    return () => {
      clearInterval(interval);
      if (wakeLockRef.current) {
        wakeLockRef.current.release();
      }
    };

  }, []);

  /**
   * alternar status entre disponível e indisponível
   */
  const alternarStatus = async (statusAtual) => {

    console.log('Entrou em alternarStatus....');

    // ligar / desligar o LoadingIndicator
    setLoadingIndicator(true);

    const mapaStatus = {
      'PILOTO DISPONÍVEL': 'indisponivel',
      'PILOTO INDISPONÍVEL': 'disponivel'
    };

    const novoStatus = mapaStatus[statusAtual.trim().toUpperCase()];
    if (!novoStatus) return;

    setStatusAtivo(novoStatus === 'disponivel');

    try {
      const cookies = Cookies.get();
      const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

      console.log('dadosCookies em alternar status: ');
      console.log(dadosCookies);

      const resposta = await atualizarStatusPiloto(dadosCookies, novoStatus);

      console.log('Resposta: ');
      console.log(resposta);

      setDadosPiloto((prev) => ({
        ...prev,
        objPiloto: {
          ...prev.objPiloto,
          nome_status: novoStatus === 'disponivel'
            ? 'PILOTO DISPONÍVEL'
            : 'PILOTO INDISPONÍVEL'
        }
      }));

      // ligar / desligar o LoadingIndicator
      setLoadingIndicator(false);

    } catch (e) {

      // ligar / desligar o LoadingIndicator
      setLoadingIndicator(false);

      alert('Não foi possível atualizar o status.');
    }
  };

const aceitarSolicitacao = async () => {
  console.log('------------xxxx--------------');
  console.log('!!! Entrou em aceitarSolicitacao...');

  // await carregarDados();

  setLoadingIndicator(true); // ligar o LoadingIndicator

  try {
    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

    console.log('dadosCookies em aceitarSolicitacao: ');
    console.log(dadosCookies);

    console.log('dadosCookies.dadosPiloto em aceitarSolicitacao: ');
    console.log(dadosCookies?.dadosPiloto);

    console.log('dadosCookies.dadosPiloto.objViagem: ');
    console.log(dadosCookies?.dadosPiloto?.objViagem);

    // aqui está errado
    console.log('=> !!! aqui está errado <= (3)');

    // 🔹 Validação
    if (!dadosCookies || !dadosCookies.dadosPiloto) {
      setLoadingIndicator(false);
      alert("Não foi possível localizar os dados do piloto.");
      return;
    }

    if (!dadosCookies.dadosPiloto.objViagem) {
      setLoadingIndicator(false);
      alert("Não foi possível localizar os dados da viagem.");
      return;
    }

    // Atualiza status do piloto para 'em viagem'
    const resposta = await atualizarStatusPiloto(dadosCookies, 'em viagem');
    console.log('resposta dados piloto: ', resposta);

    const novosDadosCookies = {
      ...dadosCookies,
      dadosPiloto: {
        ...dadosCookies.dadosPiloto,
        objPiloto: resposta.piloto.objPiloto,
        objViagem: dadosCookies.dadosPiloto.objViagem // preserva objViagem existente
      }
    };
    Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });

    setDadosPiloto((prev) => ({
      ...prev,
      objPiloto: resposta.piloto.objPiloto
    }));

    const dadosCookiesAtualizados = JSON.parse(Cookies.get().dadosCookies);

    // Atualiza status da viagem
    const respostaViagem = await atualizarStatusViagemPeloPiloto(
      dadosCookiesAtualizados,
      'VIAGEM INDO ATÉ O CLIENTE'
    );
    console.log('Resposta status viagem: ', respostaViagem);

    const novoObjetoViagem = respostaViagem.objViagemAlterarStatus;

    const novosDadosCookies2 = {
      ...dadosCookiesAtualizados,
      dadosPiloto: {
        ...dadosCookiesAtualizados.dadosPiloto,
        objViagem: novoObjetoViagem ?? dadosCookiesAtualizados.dadosPiloto.objViagem
      }
    };
    Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies2), { expires: 60 });

    setDadosPiloto((prev) => ({
      ...prev,
      objViagem: novosDadosCookies2.dadosPiloto.objViagem
    }));

    console.log('Atualização concluída, novos dados do piloto:');
    console.log(novosDadosCookies2.dadosPiloto);

    navigate(`/mapa-indo-ate-cliente`);
  } catch (e) {
    setLoadingIndicator(false);
    console.error(e);
    alert('Não foi possível aceitar a solicitação.');
  }
};



  const recusarSolicitacao = async () => {

    console.log('*******');
    console.log('Entrou em recusarSolicitacao....');

    // ligar / desligar o LoadingIndicator
    setLoadingIndicator(true);

    try {
      const cookies = Cookies.get();
      const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

      console.log('cookies: ');
      console.log(dadosCookies);
  
      if (!dadosCookies) {
        alert('Não foi possível localizar os dados do piloto.');
        return;
      }
  
      // Atualiza status do piloto
      console.log('!!! Preparando para atualizar o status do piloto... ');

      console.log('dadosCookies: ');
      console.log(dadosCookies);

      await atualizarStatusPiloto(dadosCookies, 'indisponivel');

      console.log('ok, status do piloto atualizado! ');
  
      // Recarrega cookies após a atualização
      const cookiesAtualizados = Cookies.get();
      const dadosCookiesAtualizados = cookiesAtualizados.dadosCookies 
        ? JSON.parse(cookiesAtualizados.dadosCookies) 
        : null;
  
      if (!dadosCookiesAtualizados) {
        alert('Não foi possível atualizar os dados do piloto.');
        return;
      }
  
      // Atualiza status da viagem
      console.log('!!! Preparando para atualizar o status da viagem....');

      const respostaViagem = await atualizarStatusViagemPeloPiloto(
        dadosCookies,
        'VIAGEM CANCELADA PELO PILOTO'
      );
  
      console.log('Resposta status viagem: ', respostaViagem);
  
      // Atualiza objViagem nos cookies
      const novoObjetoViagem = respostaViagem?.objViagemAlterarStatus || null;
      if (!novoObjetoViagem) {
        alert('Não foi possível atualizar a viagem.');
        return;
      }

      console.log('ok, status da viagem atualizado! ');
  
      const novosDadosCookies2 = {
        ...dadosCookiesAtualizados,
        dadosPiloto: {
          ...dadosCookiesAtualizados.dadosPiloto,
          objViagem: novoObjetoViagem
        }
      };
  
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies2), { expires: 60 });

      console.log('cookies atualizados: ');
      console.log(novosDadosCookies2);

      // ligar / desligar o LoadingIndicator
      // setLoadingIndicator(false);
  
      navigate(`/pagina-piloto-mototaxi`);
    } catch (e) {

      // ligar / desligar o LoadingIndicator
      setLoadingIndicator(false);

      console.error('Erro ao recusar solicitação:', e);
      alert('Não foi possível recusar a solicitação.');
    }
  };
  


  const handleLogout = async () => {
    setLoadingIndicator(true); // mostra loading

    try {
      const cookies = Cookies.get();
      const dadosCookies = cookies?.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

      // Se houver dados, tenta atualizar o status no servidor
      if (dadosCookies) {
        try {
          await atualizarStatusPiloto(dadosCookies, 'indisponivel');
        } catch (err) {
          // Se a chamada de atualização falhar, apenas logamos e continuamos com o logout
          console.error('Erro ao atualizar status do piloto durante logout:', err);
        }
      }

      // Remove cookies e navega para a tela de conta
      Cookies.remove('dadosCookies');
      navigate('/conta');
    } catch (err) {
      console.error('Erro no logout:', err);
      alert('Ocorreu um erro ao sair. Tente novamente.');
    } finally {
      setLoadingIndicator(false); // garante desligar loading
    }
  };


  // if (!dadosPiloto) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center vh-100 px-3">
  //       <div className="text-center">
  //         <div className="spinner-border text-primary mb-3" role="status" style={{ width: '2.5rem', height: '2.5rem' }}>
  //           <span className="visually-hidden">Carregando...</span>
  //         </div>
  //         <p className="fw-bold fs-6">Carregando dados...</p>
  //       </div>
  //     </div>
  //   );
  // }



  // CARREGAR O LOADING INDICATOR
  // if (!dadosPiloto) {
  //   setLoadingIndicator(true);
  // }


  if (loadingIndicator) {
    return <LoadingIndicator fullscreen message="Aguarde..." />;
  }



  const statusAtual = dadosPiloto.objPiloto?.nome_status;

  return (
    <div className="container-fluid px-3 mt-4 PaginaPiloto">
      {/* 🔹 input invisível para manter foco ativo */}
      {/* <input autoFocus style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }} /> */}

      {/* Áudio de alerta */}
      <audio ref={audioRef} src="/sons/alerta.mp3" preload="auto" />

      {statusAtual === 'PILOTO SOLICITADO' ? (
        <>
          <div className="card shadow-lg border-0 rounded-4 p-4 mb-4 text-center bg-light">
            <h4 className="fw-bold text-danger mb-0">🚨 Você foi solicitado!!</h4>
          </div>

          <div className="card shadow-sm border-0 rounded-4 p-4 mb-3">
            <h5 className="fw-bold mb-3 text-primary text-center">📋 Dados da Viagem</h5>
            <p className="small mb-2"><strong>Origem:</strong> {dadosPiloto.objViagem.descricao_endereco_origem}</p>
            <p className="small mb-2"><strong>Destino:</strong> {dadosPiloto.objViagem.descricao_endereco_destino}</p>
            <p className="small mb-3">
              <strong>Celular do Cliente: </strong>
              <a
                href={`https://wa.me/55${dadosPiloto.objViagem.objInternautaCliente.numero_celular_com_ddd.replace(/\D/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success btn-sm d-inline-flex align-items-center mt-2"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                  alt="WhatsApp"
                  style={{ width: "20px", height: "20px", marginRight: "8px" }}
                />
                {dadosPiloto.objViagem.objInternautaCliente.numero_celular_com_ddd}
              </a>
            </p>

            <hr className="my-3" />

            <div className="d-grid gap-3 d-md-flex justify-content-md-center mt-3">


              <button className="btn btn-success btn-lg w-100 w-md-auto" onClick={aceitarSolicitacao}>
                ✅ ACEITAR
              </button>


              <button 
                className="btn btn-danger btn-lg w-100 w-md-auto mt-2 mt-md-0"
                onClick={() => {
                  console.log('!!!!!!!!!!');
                  console.log('Clicou no botão!');
                  recusarSolicitacao();
                }}
              >
                ❌ RECUSAR
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="card shadow-sm border-0 rounded-4 p-4 mb-3 text-center">
            <h4 className="fw-bold mb-2 text-dark">{dadosPiloto.objUser.name}</h4>
            <h2>
              <strong>
                <p className={`fw-semibold mb-0 ${statusAtual === 'PILOTO DISPONÍVEL' ? 'text-success' : 'text-muted'}`}>
                  {statusAtual}
                </p>
              </strong>
            </h2>


          </div>

          <div className="d-flex justify-content-center mt-3">
            <div className="form-check form-switch">
              <input
                className="form-check-input fs-5"
                type="checkbox"
                role="switch"
                id="statusSwitch"
                checked={statusAtivo}
                onChange={() => alternarStatus(statusAtual)}
              />
              <label
                className="form-check-label ms-2 fw-semibold"
                htmlFor="statusSwitch"
                style={{ color: "#000" }}
              >
                {statusAtual === 'PILOTO DISPONÍVEL'
                  ? '🔴 Tornar Indisponível'
                  : '🟢 Tornar Disponível'}
              </label>
            </div>
          </div>
        </>
      )}

      {statusAtual !== 'PILOTO SOLICITADO' && (
        <div className="d-flex justify-content-center mt-4">
          <button onClick={handleLogout} className="btn btn-danger btn-lg w-100 w-md-auto">
            <BiExit size={22} className="me-2" /> Sair
          </button>
        </div>
      )}
    </div>
  );
};

export default PaginaPilotoMototaxi;
